// removed by extract-text-webpack-plugin
module.exports = {"container":"_L14VEH9lIKvhWnu-mHrN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/styles.css
// module id = 2758
// module chunks = 0